module.exports = __webpack_public_path__ + "img/zxcg.015e674c.png";